export default __webpack_public_path__ + "static/media/expand-icon.0e429aa8.svg";